<template>
  <el-card shadow="never">
    <table-view
      :table-model="tableModel0"
      :table-data="tableData0"
      :showPage="false"
    ></table-view>
    <table-view
      :table-model="tableModel1"
      :table-data="tableData1"
      :showPage="false"
    ></table-view>
    <table-view
      :table-model="tableModel2"
      :table-data="tableData2"
      :showPage="false"
    ></table-view>
    <table-view
      tableCardTitle="Len Operating Efficiency"
      :table-model="tableModel3"
      :table-data="tableData3"
      :showPage="false"
    />
    <table-view
      tableCardTitle="Len Payment Experience"
      :table-model="tableModel4"
      :table-data="tableData4"
      :showPage="false"
    />
    <table-view
      tableCardTitle="Len Credit Risk Monitor"
      :table-model="tableModel5"
      :table-data="tableData5"
      :showPage="false"
    />
    <table-view
      tableCardTitle="Len Subjective Factors"
      :table-model="tableModel6"
      :table-data="tableData6"
      :showPage="false"
    />
    <table-view
      tableCardTitle="Len OVERALL FINANCIAL SCORE"
      :table-model="tableModel7"
      :table-data="tableData7"
      :showPage="false"
    />
    <table-view
      tableCardTitle="Len OVERALL SCORE"
      :table-model="tableModel8"
      :table-data="tableData8"
      :showPage="false"
    />
    <table-view
      tableCardTitle="Len CREDIT LIMIT MODULE"
      :table-model="tableModel9"
      :table-data="tableData9"
      :showPage="false"
    />
    <table-view
      :table-model="tableModel10"
      :table-data="tableData10"
      :showPage="false"
    />
  </el-card>
</template>

<script>
import { getCardResultDetail } from './api'
import _ from 'lodash'

export default {
  data() {
    return {
      tableData0: [],
      tableModel0: [
        {
          label: 'Scorecard Name',
          prop: 'scoreCardName',
        },
        {
          label: 'Financial Year',
          prop: 'financialYear',
        },
      ],
      tableModel1: [
        {
          label: 'Criteria Name',
          prop: 'criteriaName',
        },
        {
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
        {
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableData1: [],
      tableModel2: [
        {
          label: 'Model Criteria Name',
          prop: 'criteriaName',
        },
        {
          label: 'Raw Score',
          prop: 'weightedScore',
        },
      ],
      tableData2: [],
      LimitDetail: {},
      tableData3: [],
      tableModel3: [
        {
          label: 'Factor Name',
          prop: 'criteriaName',
        },
        {
          label: 'Factor Value',
          prop: 'factorValue',
        },
        {
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
        {
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableData4: [],
      tableModel4: [
        {
          label: 'Factor Name',
          prop: 'criteriaName',
        },
        {
          label: 'Factor Value',
          prop: 'factorValue',
        },
        {
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
        {
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableModel5: [
        {
          label: 'Factor Name',
          prop: 'criteriaName',
        },
        {
          label: 'Factor Value',
          prop: 'factorValue',
        },
        {
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
        {
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableData5: [],
      tableData6: [],
      tableModel6: [
        {
          label: 'Factor Name',
          prop: 'criteriaName',
        },
        {
          label: 'Factor Value',
          prop: 'factorValue',
        },
        {
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
        {
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableModel7: [
        {
          label: 'Factor Name',
          prop: 'criteriaName',
        },
        {
          label: 'Factor Value',
          prop: 'factorValue',
        },
        {
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
        {
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableData7: [],
      tableModel8: [
        {
          label: 'Factor Name',
          prop: 'criteriaName',
        },
        {
          label: 'Factor Value',
          prop: 'factorValue',
        },
        {
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
        {
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableData8: [],
      tableModel9: [
        {
          label: 'Factor Name',
          prop: 'criteriaName',
        },
        {
          label: 'Factor Value',
          prop: 'factorValue',
        },
        {
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
        {
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableData9: [],
      tableModel10: [
        {
          label: 'Criteria Name',
          prop: 'criteriaName',
        },
        {
          label: 'Factor Value',
          prop: 'factorValue',
        },
        {
          label: 'Raw Score',
          prop: 'rawScore',
        },
        {
          label: 'Weight',
          prop: 'weight',
        },
        {
          label: 'Weighted Score',
          prop: 'weightedScore',
        },
      ],
      tableData10: [],
    }
  },
  mounted() {
    this._getCardResultDetail()
  },
  methods: {
    async _getCardResultDetail() {
      try {
        const {
          creditScoreCardCriteriaVOList,
          scoreCardName = '',
          financialYear = '',
        } = await getCardResultDetail(this.$route.params.id)
        this.tableData0.push({
          scoreCardName: scoreCardName,
          financialYear: financialYear,
        })
        creditScoreCardCriteriaVOList.forEach(item => {
          if (item.criteriaName === 'Financial Health') {
            item.weightedScore =
              item.factorValue =
              item.rawScore =
                this.$utils.NumFilter(
                  creditScoreCardCriteriaVOList[13].rawScore *
                    creditScoreCardCriteriaVOList[14].rawScore *
                    creditScoreCardCriteriaVOList[17].rawScore *
                    creditScoreCardCriteriaVOList[18].rawScore *
                    creditScoreCardCriteriaVOList[19].rawScore,
                )
          }
        })
        //处理千位符
        // creditScoreCardCriteriaVOList.map(item => {
        //   const regPos = /^\d+(\.\d+)?$/
        //   const regNeg =
        //     /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
        //   // if (regPos.test(item.factorValue) || regNeg.test(item.factorValue)) {
        //   //   item.factorValue = this.$utils.formatAmount(item.factorValue)
        //   // } else {
        //   //   return item.factorValue
        //   // }
        //   // if (regPos.test(item.rawScore) || regNeg.test(item.rawScore)) {
        //   //   item.rawScore = this.$utils.formatAmount(item.rawScore)
        //   // } else {
        //   //   return item.rawScore
        //   // }
        //   if (
        //     regPos.test(item.weightedScore) ||
        //     regNeg.test(item.weightedScore)
        //   ) {
        //     item.weightedScore = this.$utils.formatAmount(item.weightedScore)
        //   } else {
        //     return item.weightedScore
        //   }
        // })
        this.tableData8.push(
          creditScoreCardCriteriaVOList[22],
          creditScoreCardCriteriaVOList[25],
        )
        const tableData8_ = _.cloneDeep(this.tableData8)
        tableData8_.forEach(item => {
          if (item.criteriaName === 'Ecredit Score') {
            item.criteriaName = 'mmcreditRating'
            item.rawScore = ''
            item.weightedScore = ''
          }
        })
        this.tableData8 = tableData8_
        this.tableData1.push(
          creditScoreCardCriteriaVOList[3],
          creditScoreCardCriteriaVOList[4],
          creditScoreCardCriteriaVOList[5],
          creditScoreCardCriteriaVOList[12],
          creditScoreCardCriteriaVOList[21],
        )
        const tableData1_ = _.cloneDeep(this.tableData1)
        tableData1_.forEach(item => {
          if (item.criteriaName === 'Operating Experience') {
            item.criteriaName = 'Operating Efficiency'
          }
          if (item.criteriaName === 'Credit Risk Monitor') {
            if (item.rawScore === null) {
              //这里是没有值的情况
              tableData1_[0].weight = '5%'
              tableData1_[1].weight = '15%'
              tableData1_[2].weight = '0'
              tableData1_[3].weight = '15%'
              tableData1_[4].weight = '65%'
            } else {
              tableData1_[0].weight = '5%'
              tableData1_[1].weight = '10%'
              tableData1_[2].weight = '10%'
              tableData1_[3].weight = '10%'
              tableData1_[4].weight = '65%'
            }
          }
          // item.rawScore = this.$utils.formatAmount(item.rawScore)
          // item.rawScore = item.rawScore
        })
        tableData1_.forEach(item => {
          item.weightedScore = (
            (item.rawScore * item.weight.split('%')[0]) /
            100
          ).toFixed(3)
        })
        this.tableData1 = tableData1_
        this.tableData2.push(
          creditScoreCardCriteriaVOList[22],
          creditScoreCardCriteriaVOList[38],
        )
        this.tableData2.map(item => {
          if (item.criteriaName === 'Theoretical Limit') {
            item.weightedScore = this.$utils.formatAmount(item.weightedScore)
          }
          if (item.criteriaName === 'Weighted Score') {
            item.weightedScore = item.rawScore
          }
        })
        this.tableData3 = creditScoreCardCriteriaVOList.slice(0, 4)
        this.tableData3.forEach(item => {
          if (item.criteriaName === 'DIO') {
            item.rawScore = item.factorValue
          }
          if (item.criteriaName === 'Operating Experience') {
            item.criteriaName = 'Operating Efficiency'
          }
        })
        this.tableData4 = creditScoreCardCriteriaVOList.slice(4, 5)
        this.tableData5 = creditScoreCardCriteriaVOList.slice(5, 6)
        this.tableData6 = creditScoreCardCriteriaVOList.slice(6, 13)
        this.tableData7 = creditScoreCardCriteriaVOList.slice(13, 22)
        this.tableData7.forEach(item => {
          item.weightedScore = item.rawScore
          if (item.criteriaName === 'Profit Ability') {
            item.criteriaName = 'Profitability'
          }
        })
        this.tableData9 = creditScoreCardCriteriaVOList.slice(23, 28)
        this.tableData9.push(creditScoreCardCriteriaVOList[38])
        this.tableData9.forEach(item => {
          if (item.criteriaName === 'Lenovo Public Working Capital') {
            item.criteriaName = 'Working Capital'
          }
          if (item.criteriaName === 'Lenovo Public Tot Equity') {
            item.criteriaName = 'Equity'
          }
        })
        this.tableData10 = creditScoreCardCriteriaVOList.slice(28, 38)
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>

<style scoped></style>
